module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Highvoltage-9ef3714d7d8b41cdbe439408bfc13632.svg";